/* eslint-disable react/display-name */
import React, { useContext, useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSignOutAlt, faUserShield } from "@fortawesome/free-solid-svg-icons"
import { faEnvelopeOpen } from "@fortawesome/free-regular-svg-icons"
import { Nav, Navbar, Dropdown, Container } from "react-bootstrap"

//Translation
import { useTranslation } from "react-i18next"

import { Routes } from "../../routes"
import GetCurrentUser from "../../common/GetCurrentUser"
import { parseJwt } from "../../common/helpers"

import ClearUser from "../../common/ClearUser"
import AdminContainerModal from "../Admin/AdminContainerModal"
import { useHistory } from "react-router"

export default props => {
  const [user, setUser] = useState(null)
  const [currentOrganization, setCurrentOrganization] = useState(null)
  const [showAdmin, setShowAdmin] = useState(false)
  const history = useHistory()
  const { t } = useTranslation("global")
  useEffect(() => {
    let theUser = parseJwt(GetCurrentUser())
    setUser(theUser)

    let currntOrg = localStorage.getItem("organization")
    if (currntOrg && currntOrg !== "undefined") {
      try {
        setCurrentOrganization(JSON.parse(currntOrg))
      } catch (error) {
        console.error("Invalid organization in storage", error)
        setCurrentOrganization(null)
      }
    }
  }, [])

  return (
    <>
      {showAdmin && (
        <AdminContainerModal toggle={() => setShowAdmin(!showAdmin)} />
      )}
      <Navbar
        variant="dark"
        expanded
        className="px-2 d-none d-md-block bg-white border-bottom mb-4"
      >
        <Container fluid className="px-0">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex align-items-center">
              <span
                className="display-5 clickable"
                onClick={() => {
                  history.push(Routes.SelectOrganization.path)
                }}
              >
                {currentOrganization?.name}
                <i className="fas fa-chevron-down ms-2"></i>
              </span>
            </div>
            <Nav className="align-items-center">
              {/* <button
                className="btn me-2"
                onClick={() => {
                  props.history.push(Routes.Settings.clean)
                }}
              >
                <i className="fas fa-cog" />
              </button> */}
              {user && user.RoleId === "admin" && (
                <button
                  className="btn me-2 btn-warning mx-2"
                  onClick={() => {
                    setShowAdmin(!showAdmin)
                    // props.history.push(Routes.Admin.clean)
                  }}
                >
                  <i className="fas fa-thunderstorm" />
                </button>
              )}
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle as={Nav.Link} className=" m-0 p-0">
                  <button className="btn btn-primary">
                    <span className="bg-info p-1 px-3 rounded">
                      {user && user.Email.substring(0, 1)}
                    </span>
                    <span className="ms-2">{user && user.Email}</span>
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                  <Dropdown.Item className="fw-bold d-none">
                    <FontAwesomeIcon icon={faEnvelopeOpen} className="me-2" />{" "}
                    {t("messages")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="fw-bold"
                    as="button"
                    onClick={() => {
                      window.open("mailto:info@valegos.com", "_blank")
                    }}
                  >
                    <FontAwesomeIcon icon={faUserShield} className="me-2" />{" "}
                    {t("Support")}
                  </Dropdown.Item>

                  <Dropdown.Divider />

                  <Dropdown.Item
                    className="fw-bold"
                    onClick={() => {
                      ClearUser()
                      history.push(Routes.Home.path)
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faSignOutAlt}
                      className="text-danger me-2"
                    />{" "}
                    {t("logout")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </div>
        </Container>
      </Navbar>
    </>
  )
}
